import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import Logo from "@/components/Logo";

const LINKS = [
  { href: "#chi-siamo", label: "Chi Siamo", id: "nav-link-chi-siamo" },
  { href: "#menu", label: "Menù", id: "nav-link-menu" },
  { href: "#dj-set", label: "Serate", id: "nav-link-dj-set" },
  { href: "#galleria", label: "Galleria", id: "nav-link-galleria" },
  { href: "#contatti", label: "Contatti", id: "nav-link-contatti" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.7, duration: 0.6, ease: "easeOut" }}
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="text-[#F5F2EB]">
          <Logo small />
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              className="text-[11px] font-mono2 tracking-[0.2em] uppercase text-stone-400 hover:text-[#F49D37] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="tel:+393937347177"
          data-testid="nav-call-button"
          className="flex items-center gap-2 bg-[#D34E36] hover:bg-[#F49D37] hover:text-black text-[#F5F2EB] text-[11px] font-bold uppercase tracking-widest px-4 py-2 rounded-full transition-colors"
        >
          <Phone size={13} />
          <span className="hidden sm:inline">Chiama</span>
        </a>
      </div>
    </motion.header>
  );
}
